import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getMaxListeners } from 'process';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';


declare const Swal;


@Component({
  selector: 'information-users',
  templateUrl: './view-users.component.html',
  styleUrls: ['./view-users.component.css']
})
export class ViewInformationUsersComponent implements OnInit {


  pageNum = 1;
  public UserData: any;
  public userID;
  public page;

  public noDataEnable: boolean = false;

  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  }

  public routeType = '';
  public tableShow: boolean = false;
  public cols = [
    { key: '#', display: '#' },
    { key: 'name', display: 'User name' , headerConfig:{ isDefault: true}},
    { key: 'userEmail', display: 'Email' },
    { key: 'contactNumber', display: 'Mobile' },
    { key: 'designation', display: 'Designation' },
    // { key: 'branch', display: ' Branch' },
    { key: 'isActive', display: 'Status' },

    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          // { display: 'View', color: 'primary', icon: 'View' },
          // { display: 'Delete', color: 'warn', icon: 'Delete' },
          { display: 'Update', color: 'primary', icon: 'Edit', class:'fs-13' }
        ]
      }
    }
  ];

  

  constructor(
    public api: ApiService,
    public swal: SweetAlert,

    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {

  }


  ngOnInit(): void {
    this.getUsersList();
  }

  
  getUsersList(page = 1, limit = 10) {
      this.tableShow = false;

    const obj = {
      page: page,
      limit: limit,
    };
    this.api.transportManagerUserList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.UserData = res.data;
        this.noDataEnable = true;

      }
      this.UserData = this.UserData.map(x => {
        let obj = x;
        obj['isActive'] = obj['isActive'] == 1  ?  
          '<img src="../../../../../../assets/images/user/tick.png " width="20 ">'
          : '<img src="../../../../../../assets/images/user/cross.png " width="20 ">';

        return obj;
      })
      // console.log(this.UserData)
      this.tableShow = true;
      this.processPagination(res,obj);

    }).catch((err) => {
      console.log(err);
    });


  }

  processPagination(data, req) {
    this.tableShow = false;

    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.tableShow = true;

  }

  getTotalCount(total,limit){
    let result:any = 1;  
    if(total/limit>0){
      result = total / limit;
      if(total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data){
    this.getUsersList(data.page,data.limit);
  }

  
 

  onActionHandler(e: any) {
    console.log(e);
    const data = e.data;
    if (e.action.display.toLowerCase() == 'update') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/users/edit-users', e.data.userID]);

    } else if (e.action.display.toLowerCase() == 'delete') {
      console.log(e);
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          // this.deleteUserData(e);
        }
      });
    } else if (e.action.display.toLowerCase() == 'view') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/users/view-users', e.data.guestID]);
    }

  }

  // deleteUserData(e?) {

  //   const obj = {
  //     userID: e.data.userID,
  //   };
  //   this.api.transportManagerUserDelete(obj).then((res: any) => {
  //     if (res.status == 'success') {
  //       if(res.data == undefined || res.data ==''){
  //       this.swal.swalFunction(res.status, res.status, res.message, 2000);
  //       this.tableShow = true;
  //       this.getUsersList();
  //       }
  //       else{
  //         this.userRemovePopup(res.data);
  //       }
  //     } else {
  //       this.swal.swalFunction(res.status, res.status, res.message, 2000);
  //     }
  //   }).catch((err) => {
  //     console.log(err);
  //   });

  // }




  userRemovePopup(routes) {
    let fireContent = {
      title: 'Remove Guest from Assigned Route!',
      icon: 'warning',
    };
    if (routes.length > 0) {
      let htmlContent = '';
      for (let r = 0; r < routes.length; r++) {
        if (routes[r].title) htmlContent += `<tr><td class="border-top-0">${r + 1}</td><td class="border-top-0 text-left">${routes[r].title}</td></tr>`;
      }
      if (routes.length > 1) fireContent['title'] = 'Remove Guest from Assigned Routes!';
      fireContent['html'] = `<div class="row px-5"><div class="col-12 px-5" style="max-height:200px;overflow-y:auto;"><table class="table table-responsive table-sm">` + htmlContent + `</table></div></div>`;
      setTimeout(() => {
        Swal.fire(fireContent);
      }, 300);
    }
  }


  // status update

  updateStatus(data, index) {

    let status = data.status;
    console.log(status, status == '0');
    if (status == '0') status = '1';
    else status = '0';

    let obj = {
      userID: this.userID,
      status: Number(status),
    };



  }
}





